/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * AI Enablement Platform
 * Enterprise AI enablement analysis and recommendations platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdoptionSettingsUpdate,
  AvailableProvidersResponse,
  ComplianceTestRequest,
  ComplianceTestResponse,
  FetchModelsRequest,
  FetchModelsResponse,
  HTTPValidationError,
  ListProviderConfigurationsV1ProvidersConfigurationsGetParams,
  ListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGetParams,
  ProviderConfigurationCreate,
  ProviderConfigurationResponse,
  ProviderConfigurationUpdate,
  ProviderConnectionTestRequest,
  ProviderConnectionTestResponse,
  ProviderListResponse,
  TenantProviderListResponse,
  TenantProviderResponse,
  ToggleSharedProviderV1ProvidersSharedProviderIdTogglePutParams
} from '.././models';

import { customInstance } from '../../services/api-client';




/**
 * Get information about all available provider types that can be configured.
 * @summary List Available Provider Types
 */
export const listAvailableProvidersV1ProvidersAvailableGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<AvailableProvidersResponse>(
      {url: `/v1/providers/available`, method: 'GET', signal
    },
      );
    }
  



export const getListAvailableProvidersV1ProvidersAvailableGetQueryKey = () => {
    return [
    `/v1/providers/available`
    ] as const;
    }

    
export const getListAvailableProvidersV1ProvidersAvailableGetQueryOptions = <TData = Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAvailableProvidersV1ProvidersAvailableGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>> = ({ signal }) => listAvailableProvidersV1ProvidersAvailableGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListAvailableProvidersV1ProvidersAvailableGetQueryResult = NonNullable<Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>>
export type ListAvailableProvidersV1ProvidersAvailableGetQueryError = unknown


export function useListAvailableProvidersV1ProvidersAvailableGet<TData = Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>,
          TError,
          Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListAvailableProvidersV1ProvidersAvailableGet<TData = Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>,
          TError,
          Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListAvailableProvidersV1ProvidersAvailableGet<TData = Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Available Provider Types
 */

export function useListAvailableProvidersV1ProvidersAvailableGet<TData = Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableProvidersV1ProvidersAvailableGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListAvailableProvidersV1ProvidersAvailableGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Fetch available models from a provider using credentials (without saving configuration).
 * @summary Fetch Available Models
 */
export const fetchProviderModelsV1ProvidersFetchModelsPost = (
    fetchModelsRequest: FetchModelsRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<FetchModelsResponse>(
      {url: `/v1/providers/fetch-models`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fetchModelsRequest, signal
    },
      );
    }
  


export const getFetchProviderModelsV1ProvidersFetchModelsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fetchProviderModelsV1ProvidersFetchModelsPost>>, TError,{data: FetchModelsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof fetchProviderModelsV1ProvidersFetchModelsPost>>, TError,{data: FetchModelsRequest}, TContext> => {

const mutationKey = ['fetchProviderModelsV1ProvidersFetchModelsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fetchProviderModelsV1ProvidersFetchModelsPost>>, {data: FetchModelsRequest}> = (props) => {
          const {data} = props ?? {};

          return  fetchProviderModelsV1ProvidersFetchModelsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FetchProviderModelsV1ProvidersFetchModelsPostMutationResult = NonNullable<Awaited<ReturnType<typeof fetchProviderModelsV1ProvidersFetchModelsPost>>>
    export type FetchProviderModelsV1ProvidersFetchModelsPostMutationBody = FetchModelsRequest
    export type FetchProviderModelsV1ProvidersFetchModelsPostMutationError = HTTPValidationError

    /**
 * @summary Fetch Available Models
 */
export const useFetchProviderModelsV1ProvidersFetchModelsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fetchProviderModelsV1ProvidersFetchModelsPost>>, TError,{data: FetchModelsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof fetchProviderModelsV1ProvidersFetchModelsPost>>,
        TError,
        {data: FetchModelsRequest},
        TContext
      > => {

      const mutationOptions = getFetchProviderModelsV1ProvidersFetchModelsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Create a new AI provider configuration (OpenAI, Anthropic, Groq, Bedrock, etc.).
 * @summary Create Provider Configuration
 */
export const createProviderConfigurationV1ProvidersConfigurationsPost = (
    providerConfigurationCreate: ProviderConfigurationCreate,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ProviderConfigurationResponse>(
      {url: `/v1/providers/configurations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: providerConfigurationCreate, signal
    },
      );
    }
  


export const getCreateProviderConfigurationV1ProvidersConfigurationsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProviderConfigurationV1ProvidersConfigurationsPost>>, TError,{data: ProviderConfigurationCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createProviderConfigurationV1ProvidersConfigurationsPost>>, TError,{data: ProviderConfigurationCreate}, TContext> => {

const mutationKey = ['createProviderConfigurationV1ProvidersConfigurationsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProviderConfigurationV1ProvidersConfigurationsPost>>, {data: ProviderConfigurationCreate}> = (props) => {
          const {data} = props ?? {};

          return  createProviderConfigurationV1ProvidersConfigurationsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateProviderConfigurationV1ProvidersConfigurationsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createProviderConfigurationV1ProvidersConfigurationsPost>>>
    export type CreateProviderConfigurationV1ProvidersConfigurationsPostMutationBody = ProviderConfigurationCreate
    export type CreateProviderConfigurationV1ProvidersConfigurationsPostMutationError = HTTPValidationError

    /**
 * @summary Create Provider Configuration
 */
export const useCreateProviderConfigurationV1ProvidersConfigurationsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProviderConfigurationV1ProvidersConfigurationsPost>>, TError,{data: ProviderConfigurationCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProviderConfigurationV1ProvidersConfigurationsPost>>,
        TError,
        {data: ProviderConfigurationCreate},
        TContext
      > => {

      const mutationOptions = getCreateProviderConfigurationV1ProvidersConfigurationsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * List all provider configurations for the current user.
 * @summary List Provider Configurations
 */
export const listProviderConfigurationsV1ProvidersConfigurationsGet = (
    params?: ListProviderConfigurationsV1ProvidersConfigurationsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ProviderListResponse>(
      {url: `/v1/providers/configurations`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListProviderConfigurationsV1ProvidersConfigurationsGetQueryKey = (params?: ListProviderConfigurationsV1ProvidersConfigurationsGetParams,) => {
    return [
    `/v1/providers/configurations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListProviderConfigurationsV1ProvidersConfigurationsGetQueryOptions = <TData = Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>, TError = HTTPValidationError>(params?: ListProviderConfigurationsV1ProvidersConfigurationsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProviderConfigurationsV1ProvidersConfigurationsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>> = ({ signal }) => listProviderConfigurationsV1ProvidersConfigurationsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListProviderConfigurationsV1ProvidersConfigurationsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>>
export type ListProviderConfigurationsV1ProvidersConfigurationsGetQueryError = HTTPValidationError


export function useListProviderConfigurationsV1ProvidersConfigurationsGet<TData = Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>, TError = HTTPValidationError>(
 params: undefined |  ListProviderConfigurationsV1ProvidersConfigurationsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>,
          TError,
          Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListProviderConfigurationsV1ProvidersConfigurationsGet<TData = Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>, TError = HTTPValidationError>(
 params?: ListProviderConfigurationsV1ProvidersConfigurationsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>,
          TError,
          Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListProviderConfigurationsV1ProvidersConfigurationsGet<TData = Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>, TError = HTTPValidationError>(
 params?: ListProviderConfigurationsV1ProvidersConfigurationsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Provider Configurations
 */

export function useListProviderConfigurationsV1ProvidersConfigurationsGet<TData = Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>, TError = HTTPValidationError>(
 params?: ListProviderConfigurationsV1ProvidersConfigurationsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProviderConfigurationsV1ProvidersConfigurationsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListProviderConfigurationsV1ProvidersConfigurationsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List all provider configurations including shared platform providers.
 * @summary List Provider Configurations Including Shared
 */
export const listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet = (
    params?: ListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TenantProviderListResponse>(
      {url: `/v1/providers/configurations/with-shared`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGetQueryKey = (params?: ListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGetParams,) => {
    return [
    `/v1/providers/configurations/with-shared`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGetQueryOptions = <TData = Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>, TError = HTTPValidationError>(params?: ListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>> = ({ signal }) => listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGetQueryResult = NonNullable<Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>>
export type ListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGetQueryError = HTTPValidationError


export function useListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet<TData = Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>, TError = HTTPValidationError>(
 params: undefined |  ListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>,
          TError,
          Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet<TData = Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>, TError = HTTPValidationError>(
 params?: ListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>,
          TError,
          Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet<TData = Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>, TError = HTTPValidationError>(
 params?: ListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List Provider Configurations Including Shared
 */

export function useListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet<TData = Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>, TError = HTTPValidationError>(
 params?: ListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListProviderConfigurationsWithSharedV1ProvidersConfigurationsWithSharedGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get a specific provider configuration by ID.
 * @summary Get Provider Configuration
 */
export const getProviderConfigurationV1ProvidersConfigurationsConfigIdGet = (
    configId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ProviderConfigurationResponse>(
      {url: `/v1/providers/configurations/${configId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetProviderConfigurationV1ProvidersConfigurationsConfigIdGetQueryKey = (configId?: number,) => {
    return [
    `/v1/providers/configurations/${configId}`
    ] as const;
    }

    
export const getGetProviderConfigurationV1ProvidersConfigurationsConfigIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>, TError = HTTPValidationError>(configId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProviderConfigurationV1ProvidersConfigurationsConfigIdGetQueryKey(configId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>> = ({ signal }) => getProviderConfigurationV1ProvidersConfigurationsConfigIdGet(configId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(configId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProviderConfigurationV1ProvidersConfigurationsConfigIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>>
export type GetProviderConfigurationV1ProvidersConfigurationsConfigIdGetQueryError = HTTPValidationError


export function useGetProviderConfigurationV1ProvidersConfigurationsConfigIdGet<TData = Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>, TError = HTTPValidationError>(
 configId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>,
          TError,
          Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProviderConfigurationV1ProvidersConfigurationsConfigIdGet<TData = Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>, TError = HTTPValidationError>(
 configId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>,
          TError,
          Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProviderConfigurationV1ProvidersConfigurationsConfigIdGet<TData = Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>, TError = HTTPValidationError>(
 configId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Provider Configuration
 */

export function useGetProviderConfigurationV1ProvidersConfigurationsConfigIdGet<TData = Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>, TError = HTTPValidationError>(
 configId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviderConfigurationV1ProvidersConfigurationsConfigIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProviderConfigurationV1ProvidersConfigurationsConfigIdGetQueryOptions(configId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update an existing provider configuration.
 * @summary Update Provider Configuration
 */
export const updateProviderConfigurationV1ProvidersConfigurationsConfigIdPut = (
    configId: number,
    providerConfigurationUpdate: ProviderConfigurationUpdate,
 ) => {
      
      
      return customInstance<ProviderConfigurationResponse>(
      {url: `/v1/providers/configurations/${configId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: providerConfigurationUpdate
    },
      );
    }
  


export const getUpdateProviderConfigurationV1ProvidersConfigurationsConfigIdPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProviderConfigurationV1ProvidersConfigurationsConfigIdPut>>, TError,{configId: number;data: ProviderConfigurationUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateProviderConfigurationV1ProvidersConfigurationsConfigIdPut>>, TError,{configId: number;data: ProviderConfigurationUpdate}, TContext> => {

const mutationKey = ['updateProviderConfigurationV1ProvidersConfigurationsConfigIdPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProviderConfigurationV1ProvidersConfigurationsConfigIdPut>>, {configId: number;data: ProviderConfigurationUpdate}> = (props) => {
          const {configId,data} = props ?? {};

          return  updateProviderConfigurationV1ProvidersConfigurationsConfigIdPut(configId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProviderConfigurationV1ProvidersConfigurationsConfigIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateProviderConfigurationV1ProvidersConfigurationsConfigIdPut>>>
    export type UpdateProviderConfigurationV1ProvidersConfigurationsConfigIdPutMutationBody = ProviderConfigurationUpdate
    export type UpdateProviderConfigurationV1ProvidersConfigurationsConfigIdPutMutationError = HTTPValidationError

    /**
 * @summary Update Provider Configuration
 */
export const useUpdateProviderConfigurationV1ProvidersConfigurationsConfigIdPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProviderConfigurationV1ProvidersConfigurationsConfigIdPut>>, TError,{configId: number;data: ProviderConfigurationUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProviderConfigurationV1ProvidersConfigurationsConfigIdPut>>,
        TError,
        {configId: number;data: ProviderConfigurationUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateProviderConfigurationV1ProvidersConfigurationsConfigIdPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Delete a provider configuration.
 * @summary Delete Provider Configuration
 */
export const deleteProviderConfigurationV1ProvidersConfigurationsConfigIdDelete = (
    configId: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/v1/providers/configurations/${configId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProviderConfigurationV1ProvidersConfigurationsConfigIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProviderConfigurationV1ProvidersConfigurationsConfigIdDelete>>, TError,{configId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProviderConfigurationV1ProvidersConfigurationsConfigIdDelete>>, TError,{configId: number}, TContext> => {

const mutationKey = ['deleteProviderConfigurationV1ProvidersConfigurationsConfigIdDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProviderConfigurationV1ProvidersConfigurationsConfigIdDelete>>, {configId: number}> = (props) => {
          const {configId} = props ?? {};

          return  deleteProviderConfigurationV1ProvidersConfigurationsConfigIdDelete(configId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProviderConfigurationV1ProvidersConfigurationsConfigIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProviderConfigurationV1ProvidersConfigurationsConfigIdDelete>>>
    
    export type DeleteProviderConfigurationV1ProvidersConfigurationsConfigIdDeleteMutationError = HTTPValidationError

    /**
 * @summary Delete Provider Configuration
 */
export const useDeleteProviderConfigurationV1ProvidersConfigurationsConfigIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProviderConfigurationV1ProvidersConfigurationsConfigIdDelete>>, TError,{configId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProviderConfigurationV1ProvidersConfigurationsConfigIdDelete>>,
        TError,
        {configId: number},
        TContext
      > => {

      const mutationOptions = getDeleteProviderConfigurationV1ProvidersConfigurationsConfigIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Test provider connection and credentials.
 * @summary Test Provider Connection
 */
export const testProviderConnectionV1ProvidersConfigurationsConfigIdTestPost = (
    configId: number,
    providerConnectionTestRequest: ProviderConnectionTestRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ProviderConnectionTestResponse>(
      {url: `/v1/providers/configurations/${configId}/test`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: providerConnectionTestRequest, signal
    },
      );
    }
  


export const getTestProviderConnectionV1ProvidersConfigurationsConfigIdTestPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testProviderConnectionV1ProvidersConfigurationsConfigIdTestPost>>, TError,{configId: number;data: ProviderConnectionTestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof testProviderConnectionV1ProvidersConfigurationsConfigIdTestPost>>, TError,{configId: number;data: ProviderConnectionTestRequest}, TContext> => {

const mutationKey = ['testProviderConnectionV1ProvidersConfigurationsConfigIdTestPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testProviderConnectionV1ProvidersConfigurationsConfigIdTestPost>>, {configId: number;data: ProviderConnectionTestRequest}> = (props) => {
          const {configId,data} = props ?? {};

          return  testProviderConnectionV1ProvidersConfigurationsConfigIdTestPost(configId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TestProviderConnectionV1ProvidersConfigurationsConfigIdTestPostMutationResult = NonNullable<Awaited<ReturnType<typeof testProviderConnectionV1ProvidersConfigurationsConfigIdTestPost>>>
    export type TestProviderConnectionV1ProvidersConfigurationsConfigIdTestPostMutationBody = ProviderConnectionTestRequest
    export type TestProviderConnectionV1ProvidersConfigurationsConfigIdTestPostMutationError = HTTPValidationError

    /**
 * @summary Test Provider Connection
 */
export const useTestProviderConnectionV1ProvidersConfigurationsConfigIdTestPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testProviderConnectionV1ProvidersConfigurationsConfigIdTestPost>>, TError,{configId: number;data: ProviderConnectionTestRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testProviderConnectionV1ProvidersConfigurationsConfigIdTestPost>>,
        TError,
        {configId: number;data: ProviderConnectionTestRequest},
        TContext
      > => {

      const mutationOptions = getTestProviderConnectionV1ProvidersConfigurationsConfigIdTestPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Enable or disable a shared provider for your tenant.
 * @summary Toggle Shared Provider
 */
export const toggleSharedProviderV1ProvidersSharedProviderIdTogglePut = (
    providerId: number,
    params: ToggleSharedProviderV1ProvidersSharedProviderIdTogglePutParams,
 ) => {
      
      
      return customInstance<TenantProviderResponse>(
      {url: `/v1/providers/shared/${providerId}/toggle`, method: 'PUT',
        params
    },
      );
    }
  


export const getToggleSharedProviderV1ProvidersSharedProviderIdTogglePutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleSharedProviderV1ProvidersSharedProviderIdTogglePut>>, TError,{providerId: number;params: ToggleSharedProviderV1ProvidersSharedProviderIdTogglePutParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof toggleSharedProviderV1ProvidersSharedProviderIdTogglePut>>, TError,{providerId: number;params: ToggleSharedProviderV1ProvidersSharedProviderIdTogglePutParams}, TContext> => {

const mutationKey = ['toggleSharedProviderV1ProvidersSharedProviderIdTogglePut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleSharedProviderV1ProvidersSharedProviderIdTogglePut>>, {providerId: number;params: ToggleSharedProviderV1ProvidersSharedProviderIdTogglePutParams}> = (props) => {
          const {providerId,params} = props ?? {};

          return  toggleSharedProviderV1ProvidersSharedProviderIdTogglePut(providerId,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ToggleSharedProviderV1ProvidersSharedProviderIdTogglePutMutationResult = NonNullable<Awaited<ReturnType<typeof toggleSharedProviderV1ProvidersSharedProviderIdTogglePut>>>
    
    export type ToggleSharedProviderV1ProvidersSharedProviderIdTogglePutMutationError = HTTPValidationError

    /**
 * @summary Toggle Shared Provider
 */
export const useToggleSharedProviderV1ProvidersSharedProviderIdTogglePut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleSharedProviderV1ProvidersSharedProviderIdTogglePut>>, TError,{providerId: number;params: ToggleSharedProviderV1ProvidersSharedProviderIdTogglePutParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleSharedProviderV1ProvidersSharedProviderIdTogglePut>>,
        TError,
        {providerId: number;params: ToggleSharedProviderV1ProvidersSharedProviderIdTogglePutParams},
        TContext
      > => {

      const mutationOptions = getToggleSharedProviderV1ProvidersSharedProviderIdTogglePutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Update adoption tracking settings for a provider configuration.
 * @summary Update Adoption Settings
 */
export const updateProviderAdoptionSettingsV1ProvidersConfigurationsConfigIdAdoptionPut = (
    configId: number,
    adoptionSettingsUpdate: AdoptionSettingsUpdate,
 ) => {
      
      
      return customInstance<TenantProviderResponse>(
      {url: `/v1/providers/configurations/${configId}/adoption`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adoptionSettingsUpdate
    },
      );
    }
  


export const getUpdateProviderAdoptionSettingsV1ProvidersConfigurationsConfigIdAdoptionPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProviderAdoptionSettingsV1ProvidersConfigurationsConfigIdAdoptionPut>>, TError,{configId: number;data: AdoptionSettingsUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateProviderAdoptionSettingsV1ProvidersConfigurationsConfigIdAdoptionPut>>, TError,{configId: number;data: AdoptionSettingsUpdate}, TContext> => {

const mutationKey = ['updateProviderAdoptionSettingsV1ProvidersConfigurationsConfigIdAdoptionPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProviderAdoptionSettingsV1ProvidersConfigurationsConfigIdAdoptionPut>>, {configId: number;data: AdoptionSettingsUpdate}> = (props) => {
          const {configId,data} = props ?? {};

          return  updateProviderAdoptionSettingsV1ProvidersConfigurationsConfigIdAdoptionPut(configId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProviderAdoptionSettingsV1ProvidersConfigurationsConfigIdAdoptionPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateProviderAdoptionSettingsV1ProvidersConfigurationsConfigIdAdoptionPut>>>
    export type UpdateProviderAdoptionSettingsV1ProvidersConfigurationsConfigIdAdoptionPutMutationBody = AdoptionSettingsUpdate
    export type UpdateProviderAdoptionSettingsV1ProvidersConfigurationsConfigIdAdoptionPutMutationError = HTTPValidationError

    /**
 * @summary Update Adoption Settings
 */
export const useUpdateProviderAdoptionSettingsV1ProvidersConfigurationsConfigIdAdoptionPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProviderAdoptionSettingsV1ProvidersConfigurationsConfigIdAdoptionPut>>, TError,{configId: number;data: AdoptionSettingsUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProviderAdoptionSettingsV1ProvidersConfigurationsConfigIdAdoptionPut>>,
        TError,
        {configId: number;data: AdoptionSettingsUpdate},
        TContext
      > => {

      const mutationOptions = getUpdateProviderAdoptionSettingsV1ProvidersConfigurationsConfigIdAdoptionPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Test if an API key has access to the ChatGPT Enterprise Compliance API.
 * @summary Test Compliance API Access
 */
export const testComplianceApiV1ProvidersTestComplianceApiPost = (
    complianceTestRequest: ComplianceTestRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ComplianceTestResponse>(
      {url: `/v1/providers/test-compliance-api`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: complianceTestRequest, signal
    },
      );
    }
  


export const getTestComplianceApiV1ProvidersTestComplianceApiPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testComplianceApiV1ProvidersTestComplianceApiPost>>, TError,{data: ComplianceTestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof testComplianceApiV1ProvidersTestComplianceApiPost>>, TError,{data: ComplianceTestRequest}, TContext> => {

const mutationKey = ['testComplianceApiV1ProvidersTestComplianceApiPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testComplianceApiV1ProvidersTestComplianceApiPost>>, {data: ComplianceTestRequest}> = (props) => {
          const {data} = props ?? {};

          return  testComplianceApiV1ProvidersTestComplianceApiPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TestComplianceApiV1ProvidersTestComplianceApiPostMutationResult = NonNullable<Awaited<ReturnType<typeof testComplianceApiV1ProvidersTestComplianceApiPost>>>
    export type TestComplianceApiV1ProvidersTestComplianceApiPostMutationBody = ComplianceTestRequest
    export type TestComplianceApiV1ProvidersTestComplianceApiPostMutationError = HTTPValidationError

    /**
 * @summary Test Compliance API Access
 */
export const useTestComplianceApiV1ProvidersTestComplianceApiPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testComplianceApiV1ProvidersTestComplianceApiPost>>, TError,{data: ComplianceTestRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testComplianceApiV1ProvidersTestComplianceApiPost>>,
        TError,
        {data: ComplianceTestRequest},
        TContext
      > => {

      const mutationOptions = getTestComplianceApiV1ProvidersTestComplianceApiPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Test if a saved provider configuration has access to the ChatGPT Enterprise Compliance API.
 * @summary Test Compliance API for Saved Provider
 */
export const testComplianceForProviderV1ProvidersConfigurationsConfigIdTestCompliancePost = (
    configId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ComplianceTestResponse>(
      {url: `/v1/providers/configurations/${configId}/test-compliance`, method: 'POST', signal
    },
      );
    }
  


export const getTestComplianceForProviderV1ProvidersConfigurationsConfigIdTestCompliancePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testComplianceForProviderV1ProvidersConfigurationsConfigIdTestCompliancePost>>, TError,{configId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof testComplianceForProviderV1ProvidersConfigurationsConfigIdTestCompliancePost>>, TError,{configId: number}, TContext> => {

const mutationKey = ['testComplianceForProviderV1ProvidersConfigurationsConfigIdTestCompliancePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testComplianceForProviderV1ProvidersConfigurationsConfigIdTestCompliancePost>>, {configId: number}> = (props) => {
          const {configId} = props ?? {};

          return  testComplianceForProviderV1ProvidersConfigurationsConfigIdTestCompliancePost(configId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TestComplianceForProviderV1ProvidersConfigurationsConfigIdTestCompliancePostMutationResult = NonNullable<Awaited<ReturnType<typeof testComplianceForProviderV1ProvidersConfigurationsConfigIdTestCompliancePost>>>
    
    export type TestComplianceForProviderV1ProvidersConfigurationsConfigIdTestCompliancePostMutationError = HTTPValidationError

    /**
 * @summary Test Compliance API for Saved Provider
 */
export const useTestComplianceForProviderV1ProvidersConfigurationsConfigIdTestCompliancePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testComplianceForProviderV1ProvidersConfigurationsConfigIdTestCompliancePost>>, TError,{configId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testComplianceForProviderV1ProvidersConfigurationsConfigIdTestCompliancePost>>,
        TError,
        {configId: number},
        TContext
      > => {

      const mutationOptions = getTestComplianceForProviderV1ProvidersConfigurationsConfigIdTestCompliancePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    